// @flow
import { createRef, useState } from "react";
import { TextInput } from "@nested/brand";
import { Heading, QuestionWrapper } from "../components";
import { useDesktopFocus } from "../hooks/useDesktopFocus";
import { type QuestionProps } from "../components/MultiStageForm";
import { validatePresence } from "./validators";

const validate = async (email = {}) => {
  const result = await validatePresence(
    "email",
    "Please enter a valid email address",
  )(email?.email);

  return { ...result };
};

type EmailAdditionalProps = { descriptionCopy?: string };
type EmailProps = QuestionProps<"email"> & EmailAdditionalProps;

export const ManualOnboardingEmail = ({
  ActionButtons,
  BackButton,
  initialValue,
  next,
  valid,
  validationErrors,
}: EmailProps) => {
  const [email, setEmail] = useState(initialValue?.email || "");
  const ref = createRef();
  useDesktopFocus(ref);

  // Hardcoding this to true so that I don't have to tamper with State
  // see packages/onboarding-form/src/components/MultiStageForm/ducks.js
  const privacyPolicyConsent = true;

  return (
    <QuestionWrapper
      next={() => next({ email, privacyPolicyConsent }, validate)}
    >
      <BackButton />
      <Heading>What's your email address?</Heading>

      <TextInput
        className="fs-exclude"
        errorMessage={validationErrors.email}
        hasErrors={!valid}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Email address"
        ref={ref}
        type="email"
        value={email}
      />
      <ActionButtons />
    </QuestionWrapper>
  );
};
